import React from 'react';
import classNames from 'classnames';

const defaultMessages = [
  'Building your itinerary…',
  'Checking dates…',
  'Personalizing recommendations…',
  'Mapping out local hotspots…',
  'Verifying availability…',
  'Consulting insider tips…',
  'Fine-tuning details…',
  'Forecasting the weather…',
  'Sourcing unique experiences…',
  'Curating local events…',
  'Checking transport schedules…',
  'Aligning seasonal highlights…',
  'Researching hidden cafés…',
  'Fine‑tuning your route…',
  'Tailoring cultural tips…',
  'Locking in insider secrets…',
  'Packaging your plan…',
];

export default function LoaderScreen({
  index = 0,
  percent = 0,
  finalizing = false,
  additionalMessages = []
}) {
  const messages = finalizing
    ? ['Finalizing your perfect trip…']
    : [...defaultMessages, ...additionalMessages];

  return (
    <div className="flex flex-col items-center justify-center flex-1 p-6">
      <div
        className="w-16 h-16 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mb-4"
      />

      <div className="w-full max-w-xs bg-gray-200 rounded-full h-2 mb-2">
        <div
          className={classNames(
            'h-2 rounded-full transition-all duration-500',
            finalizing ? 'bg-green-500' : 'bg-blue-500'
          )}
          style={{ width: `${Math.min(percent, 100)}%` }}
        />
      </div>

      <p className="text-sm text-gray-600 mb-2">{`${Math.floor(
        Math.min(percent, 100)
      )}%`}</p>

      <p className="text-gray-700 text-center">
        {messages[index % messages.length]}
      </p>
    </div>
  );
}